import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../../api/api";
import "../../../../components/table.css";
import EditImg from "../../../../image/Edit.svg";
import ViewImg from "../../../../image/View.svg";
import ReceivedImg from "../../../../image/Received.svg";
import Pagination from "../../../../components/Pagination";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import usePagination from "../../../../utils/usePagination";
import Table from "../../../../components/table";

const ViewEnquiries = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(enquiries, 5);

  useEffect(() => {
    const fetchEnquiries = async () => {
      try {
        const response = await api.get("/enquiry/enquiries");
        setEnquiries(response.data);
      } catch (error) {
        console.error("Failed to fetch enquiries:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEnquiries();
  }, []);

  const columns = [
    { label: "Enquiry No.", accessor: "enq_id" },
    { label: "Company Name", accessor: "client_company" },
    { label: "POL", accessor: "pol" },
    { label: "POD", accessor: "pod" },
    { label: "Shipper Name", accessor: "first_shipper_name" },
    { label: "Consignee Name", accessor: "first_consignee_name" },
    { label: "Status", accessor: "Status_client" },
       {
      label: "Date",
      render: (row) => {
        const createdAt = row.creation_date || row.creation_date;
        if (!createdAt) return "-";
        const [d, t] = createdAt.split("T");
        const [h, m] = t.split(":");
        const hr = h % 12 || 12
        return `${d} ${hr}:${m} ${h >= 12 ? "PM" : "AM"}`;
      },
    },
    {
      label: "Action",
      render: (row) => (
        <>
          {row.Status_client === "Enquiry Created" ? (
            <>
              <Link to={`/my-enquiry/view-enquiry-details/${row.enq_id}`} title="View">
                <img src={ViewImg} alt="View" width={20} height={20} />
              </Link>
              <Link to={`/my-enquiry/edit-enquiry/${row.enq_id}`} title="Edit">
                <img src={EditImg} alt="Edit" width={20} height={20} />
              </Link>
            </>
          ) : row.Status_client === "Quotation Received" ? (
            <Link to={`/view-quotation/${row.enq_id}`} title="View">
              <img src={ReceivedImg} alt="Quotation Received" width={20} height={20} />
            </Link>
          ) : null}
        </>
      ),
    },
  ];

  return (
    <>
      <Breadcrumbs />
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No enquiries found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
    </>
  );
};

export default ViewEnquiries;
